import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { useForm } from "../../shared/hooks/form-hook";
// import Input from "../../shared/components/FormElements/Input";
// import Button from "../../shared/components/FormElements/Button";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
// import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
// import {
//   VALIDATOR_MINLENGTH,
//   VALIDATOR_REQUIRE,
// } from "../../shared/util/validators";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from "../../shared/context/auth-context";

import "./NewInstrument.css";

const Scanner = () => {
  const auth = useContext(AuthContext);

  let navigate;
  navigate = useNavigate();

  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const [formState, inputHandler] = useForm({
    ticker: {
      value: "",
      isValid: false,
    },
    title: {
      value: "",
      isValid: false,
    }
  });

  const handleCancel = (event) => {
    event.preventDefault();
    navigate("/");
  };

  const newInstrumentSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      await sendRequest(
        "/api/instruments/",
        "POST",
        JSON.stringify({
          ticker: formState.inputs.ticker.value,
          title: formState.inputs.title.value,
          triggerThresholds: {
            RSI_BUY: 30,
            RSI_SELL: 80,
            MACD_BUY: 1,
            MACD_SELL: -1,
          },
          taParameters: {
            MACD_slow: 29,
            MACD_fast: 9,
            MACD_signal: 16,
          },
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      navigate("/");
    } catch (err) {
      console.error("FRequest Failed:", err);
    }
  };

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      <div>
        <h1>Find all instruments that fullfil the following criteria:</h1>
        <ul>
          <li>Gross Margin &gt; 50%</li>
          <li>Debt/Capital &lt; 50%</li>
          <li>Return on Equity &gt; 15%</li>
          <li>Return on Invested Capital &gt; 15%</li>
        </ul>
        <p>
          Add a button, to add the instrument to the portfolio watch list.
        </p>
      </div>
    </React.Fragment>
  );
};

export default Scanner;
